export { default } from "./SponsoredVideo";
